import React from 'react';

import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box, COLORS, Text } from '@clutter/clean';

import { PASSWORD_CHECKS } from '@shared/config/password';

const PasswordStrengthCheck: React.FC<{
  password: string;
  regex: RegExp;
  description: string;
}> = ({ password, regex, description }) => {
  const valid = password && regex.test(password);
  return (
    <Text.Callout color={valid ? COLORS.storm : COLORS.toucan}>
      <FontAwesomeIcon fixedWidth icon={valid ? faCheck : faTimes} />
      {description}
    </Text.Callout>
  );
};

export const PasswordStrength: React.FC<{
  password: string;
}> = ({ password }) => (
  <Box.Flex flexDirection="column" gap="2px">
    {PASSWORD_CHECKS.map((check, index) => (
      <PasswordStrengthCheck key={index} password={password} {...check} />
    ))}
  </Box.Flex>
);
